export class LoadingMask {
  constructor(
    HTMLElement: Element,
    { maskText, classes }: { maskText: string; classes?: string[] }
  ) {
    this.HTMLElement = HTMLElement;
    this.ParentHTMLElement = HTMLElement.parentElement;
    let previousNode: ChildNode;
    this.ParentHTMLElement?.childNodes.forEach((node, index) => {
      if (node === this.HTMLElement) {
        this.PreviousChildElement = previousNode;
      }
      previousNode = node;
    });

    this.MaskElement = document.createElement('div');
    this.MaskElement.classList.add('loading-mask');

    if (classes) {
      this.MaskElement.classList.add(...classes);
    }

    const MaskContainerDiv = document.createElement('div');
    MaskContainerDiv.classList.add('mask-container');

    const MaskTextSpinnerDiv = document.createElement('div');
    MaskTextSpinnerDiv.classList.add('mask-text-spinner', 'centered');

    const MaskTextContainerDiv = document.createElement('div');

    const MaskTextLabel = document.createElement('label');
    MaskTextLabel.classList.add('fs-34');
    MaskTextLabel.innerText = maskText;

    const SpinnerDiv = document.createElement('div');
    SpinnerDiv.classList.add('spinner-border', 'text-primary', 'mask-spinner');

    this.MaskElement.appendChild(MaskContainerDiv);
    this.MaskElement.appendChild(HTMLElement);
    MaskContainerDiv.appendChild(MaskTextSpinnerDiv);
    MaskTextSpinnerDiv.appendChild(MaskTextContainerDiv);
    MaskTextContainerDiv.appendChild(MaskTextLabel);
    MaskTextSpinnerDiv.appendChild(SpinnerDiv);

    if (this.ParentHTMLElement) {
      let previousElement: Element | null = null;
      let node = this.PreviousChildElement;
      while (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          previousElement = node as Element;
          break;
        }
        node = node.previousSibling ?? undefined;
      }
      if (previousElement) {
        previousElement.insertAdjacentElement('afterend', this.MaskElement);
      } else {
        this.ParentHTMLElement.insertBefore(
          this.MaskElement,
          this.ParentHTMLElement.firstChild
        );
      }
    }
  }

  destroy() {
    this.MaskElement.remove();

    if (this.ParentHTMLElement) {
      this.ParentHTMLElement.insertBefore(
        this.HTMLElement,
        this.ParentHTMLElement.firstChild
      );
    }
  }

  HTMLElement: Element;
  ParentHTMLElement: HTMLElement | null = null;
  PreviousChildElement?: ChildNode;
  MaskElement: HTMLDivElement;
}
